module.exports = __webpack_public_path__ + "static/media/HEAT_2019_pic.bac981b8.jpg";